import axios from 'axios';
import ErrorUtil from '../../../util/ErrorUtil';
export const API = axios.create({
    timeout: 10000,
});
class JSONController {
    constructor() {
        this.cancelToken = axios.CancelToken.source();
        this.isCancel = (e) => {
            var _a;
            const isAbortByBrowser = (e === null || e === void 0 ? void 0 : e.code) === 'ECONNABORTED' && ((_a = e === null || e === void 0 ? void 0 : e.message) === null || _a === void 0 ? void 0 : _a.includes('Request aborted'));
            return axios.isCancel(e) || isAbortByBrowser;
        };
        this.abort = () => {
            this.cancelToken.cancel();
            this.cancelToken = axios.CancelToken.source();
        };
    }
    async fetch(url, config) {
        this.abort();
        try {
            return (await API.get(url, { ...config, cancelToken: this.cancelToken.token })).data;
        }
        catch (e) {
            if (!this.isCancel(e)) {
                ErrorUtil.pushErrorToTeliaRum(e);
            }
            throw e;
        }
    }
    async put(url, data, config) {
        this.abort();
        try {
            return (await API.put(url, data, {
                ...config,
                cancelToken: this.cancelToken.token,
            })).data;
        }
        catch (e) {
            if (!this.isCancel(e)) {
                ErrorUtil.pushErrorToTeliaRum(e);
            }
            throw e;
        }
    }
}
export default JSONController;
